import { render, staticRenderFns } from "./DocumentsEdit.vue?vue&type=template&id=7cdf0116&scoped=true"
import script from "./DocumentsEdit.vue?vue&type=script&lang=js"
export * from "./DocumentsEdit.vue?vue&type=script&lang=js"
import style0 from "./DocumentsEdit.vue?vue&type=style&index=0&id=7cdf0116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdf0116",
  null
  
)

export default component.exports